import { render, staticRenderFns } from "./EditorHeaderButtonDownload.vue?vue&type=template&id=9a24f230&scoped=true"
import script from "./EditorHeaderButtonDownload.vue?vue&type=script&lang=js"
export * from "./EditorHeaderButtonDownload.vue?vue&type=script&lang=js"
import style0 from "./EditorHeaderButtonDownload.vue?vue&type=style&index=0&id=9a24f230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a24f230",
  null
  
)

export default component.exports